/* CNTRD email capture popup — delay + exit-intent, once per 30 days,
   AJAX submit of Shopify's native customer form, reveals WELCOME10. */
(function () {
  'use strict';
  var KEY = 'cn_pop_v1';
  var DAYS = 30;
  var shown = false;

  function seen() {
    try {
      var v = localStorage.getItem(KEY);
      if (!v) return false;
      return (Date.now() - Number(v)) < DAYS * 864e5;
    } catch (e) { return false; }
  }
  function mark() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }

  function pop() { return document.querySelector('[data-cn-pop]'); }

  function open() {
    var el = pop();
    if (!el || shown || seen()) return;
    if (window.Shopify && Shopify.designMode) return;
    shown = true;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    mark();
  }
  function close() {
    var el = pop();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    setTimeout(function () { el.hidden = true; }, 300);
  }

  function showSuccess() {
    var el = pop();
    if (!el) return;
    var f = el.querySelector('[data-cn-pop-form]');
    var s = el.querySelector('[data-cn-pop-success]');
    if (f) f.hidden = true;
    if (s) s.hidden = false;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
  }

  // Native submit (AJAX to /contact is blocked with 403). We validate, flag a
  // pending state, then let Shopify's customer form submit normally. On reload
  // (?customer_posted=true) we re-open the popup in success mode.
  function submit(e, form) {
    var err = form.querySelector('[data-cn-pop-error]');
    var email = form.querySelector('.cn-pop__email');
    if (!email || !email.value || email.value.indexOf('@') < 1) {
      e.preventDefault();
      if (err) err.hidden = false;
      return;
    }
    if (err) err.hidden = true;
    var btn = form.querySelector('.cn-pop__submit');
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    try { sessionStorage.setItem('cn_pop_pending', '1'); } catch (e2) {}
    mark();
    // allow the native POST to proceed (no preventDefault)
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest && t.closest('[data-cn-pop-close]')) { e.preventDefault(); close(); return; }
    var codeBtn = t.closest && t.closest('[data-cn-pop-code]');
    if (codeBtn) {
      var code = codeBtn.textContent.trim();
      try { navigator.clipboard.writeText(code); } catch (e2) {}
      var c = document.querySelector('[data-cn-pop-copied]');
      if (c) c.hidden = false;
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('[data-cn-pop-customer]')) {
      submit(e, form);
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function arm() {
    // Returning from a successful native submit → show success + reveal code
    var pending = false;
    try { pending = sessionStorage.getItem('cn_pop_pending') === '1'; } catch (e) {}
    if (/[?&]customer_posted=true/.test(location.search) && pending) {
      try { sessionStorage.removeItem('cn_pop_pending'); } catch (e) {}
      showSuccess();
      return;
    }
    if (seen()) return;
    // Paid traffic lands on collection pages; never cover the grid there.
    if (/^\/collections\//.test(location.pathname)) return;
    var touch = window.matchMedia('(pointer: coarse)').matches || ('ontouchstart' in window);
    if (touch) {
      // Mobile: time-delay ONLY. No exit-intent (synthetic mouseout misfires) and
      // no scroll trigger (it fired when users reached the bottom, blocking the
      // pagination/quick-add taps underneath the modal).
      setTimeout(open, 30000);
    } else {
      setTimeout(open, 12000); // desktop time-delay
      document.addEventListener('mouseout', function (e) { // desktop exit-intent
        if (!e.relatedTarget && e.clientY <= 0) open();
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else { arm(); }
})();
